<template>
  <Search />
</template>

<script>
import Search from '@/components/Search';
export default {
  components: {
    Search
  },
  nuxtI18n: {
    paths: {
      en: '/free-vectors/p/:page',
      es: '/vectores-gratis/p/:page',
      pt: '/vetores-gratis/p/:page'
    }
  }
};
</script>

<style></style>
